import ConversationsTaxonomyContainer from '../containers/ConversationsTaxonomyContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationsTaxonomyCardContent = ({
  threadId
}) => {
  return /*#__PURE__*/_jsx(ConversationsTaxonomyContainer, {
    threadId: threadId
  });
};
export const ConversationsTaxonomyCardTitle = () => {
  return 'About this conversation';
};